/*
 * @FilePath: CesiumMeasure.js
 * @Author: chenwei
 * @Date: 2022-02-24 09:46:29
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-21 14:06:29
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
 */
const Cesium = window.Cesium
export default class Cesium_measure{
    constructor(viewer,unit){
        this.unit = unit
        this.viewer = viewer
        this.handlerDis = null;
        this.pickPointEnabled = false;
        this.handlerArea = null
    }
    initCeJu(){
        let that = this
        //初始化测量距离
        that.handlerDis = new Cesium.MeasureHandler(that.viewer, Cesium.MeasureMode.Distance);
        //注册测距功能事件
        that.handlerDis.measureEvt.addEventListener(function (result) {
        var dis = Number(result.distance);
        var distance
        switch (that.unit) {
            case 'g':
                distance = dis > 1000 ? (dis / 1000).toFixed(2) + '公里' : dis.toFixed(2) + '米';
                break;
            case 'y':
                
                distance = dis > 1000 ? (dis / 1000 * 0.6213).toFixed(2) + '英里' : dis.toFixed(2) + '米';
                break;
        
            default:
                distance = dis > 1000 ? (dis / 1000 * 0.5399).toFixed(2) + '海里' : dis.toFixed(2) + '米';
                break;
        }
        // var distance = dis > 1000 ? (dis / 1000).toFixed(2) + 'km' : dis.toFixed(2) + 'm';
        that.handlerDis.disLabel.text = '距离:' + distance;
        });
        that.handlerDis.activeEvt.addEventListener(function (isActive) {
            if (isActive == true) {
                that.viewer.enableCursorStyle = false;
                that.viewer._element.style.cursor = '';
                that.viewer.scene.pickPointEnabled = that.pickPointEnabled;
            }
            else {
                that.viewer.enableCursorStyle = true;
                that.viewer.scene.pickPointEnabled = false;
            }
        });
    }
    initCemian(){
        let that = this
        that.handlerArea = new Cesium.MeasureHandler(that.viewer, Cesium.MeasureMode.Area);
        that.handlerArea.measureEvt.addEventListener(function (result) {
            var mj = Number(result.area);
            var area = mj > 1000000 ? (mj / 1000000).toFixed(2) + 'km²' : mj.toFixed(2) + '㎡'
            that.handlerArea.areaLabel.text = '面积:' + area;
        });
        that.handlerArea.activeEvt.addEventListener(function (isActive) {
            if (isActive == true) {
                that.viewer.enableCursorStyle = false;
                that.viewer._element.style.cursor = '';
                that.viewer.scene.pickPointEnabled = that.pickPointEnabled;
            }
            else {
                that.viewer.enableCursorStyle = true;
                that.viewer.scene.pickPointEnabled = false;
            }
        });
    }
    ceju(val){
        this.unit = val
        this.clearAll()
        this.deactiveAll();
        this.handlerDis && this.handlerDis.activate();
    }
    cemian(){
        this.clearAll()
        this.deactiveAll();
        this.handlerArea && this.handlerArea.activate();
    }
    clearAll(){
        this.deactiveAll()
        this.handlerDis &&  this.handlerDis.clear();
        this.handlerArea &&  this.handlerArea.clear();
    }
    deactiveAll(){
        this.handlerDis &&  this.handlerDis.deactivate();
        this.handlerArea &&  this.handlerArea.deactivate();
    }
}